var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-process-bar"},_vm._l((_vm.barData),function(item,index){return _c('div',{key:index,staticClass:"bar-item",class:{'is-cur': item.isCur, 'is-prev': item.isPrev},style:({'z-index': 100 - index})},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }